import { useDeleteAuthLogoutMutation } from '@/api/serverApi'
import { ChevronIcon, PopoverMenu, UserAvatar } from '@cfs-fixings/shared'
import { useNavigate } from 'react-router-dom'

type ProfileDropdownProps = {
  user?: {
    name: string
    profile_picture_url?: string
  },
  size?: 'small' | 'medium'
}


const ProfileDropdown = ({ user, size = 'medium' }: ProfileDropdownProps) => {
  const navigate = useNavigate()

  const [logout] = useDeleteAuthLogoutMutation()

  return (
    <PopoverMenu
      buttonContent={(
        <div className="flex items-center justify-end">
          <UserAvatar
            user={user}
            size={size}
          />

          {
            size === 'medium'
            && <>
              <span className="text-gray-900 font-medium text-sm capitalize mr-[10px] ml-1.5 hidden lg:block">
                {user?.name ?? ''}
              </span>
              <ChevronIcon className="w-[10px] h-[10px] hidden lg:block" />
            </>
          }
        </div>
      )}
    >
      <PopoverMenu.Item onClick={() => navigate('/profile')}>
        Edit Profile
      </PopoverMenu.Item>
      <PopoverMenu.Item onClick={() => logout({ body: [] })}>
        Logout
      </PopoverMenu.Item>
    </PopoverMenu>
  )
}

export default ProfileDropdown
